<div class="ai-summary-loader" style="margin-bottom: 20px">
  <app-mmp-ai-summary
    [progressTagMsg]="progressTagMsg"
    progressTagClass="inprogress"
    [progressTimeText]="progressTimeText"
  ></app-mmp-ai-summary>
</div>
@for (loader of totalLoader; track loader) {
  <div class="content-loader">
    <div class="first-loader">
      <div class="shimmer-bar shimmer-bar-single"></div>
    </div>
    <div class="loader-unit">
      @for (row of rows; track row) {
        <div class="row">
          @for (col of cols; track col) {
            <div class="col">
              <div class="shimmer-bar shimmer-bar-row"></div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
